import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import View from './mainView';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<View />} />
      </Routes>
    </Router>
  );
}

export default App;  